<script setup>
import { themeConfig } from '@themeConfig'

const pagesList = [
  {
    name: 'LinkBarPolitics',
    to: { name: 'rules-politicas' },
  },
  {
    name: 'LinkBarTerms',
    to: { name: 'rules-terminos' },
    isNew: true,
  },
  {
    name: 'LinkBarCertificate',
    to: { name: 'rules-licencia' },
  },
]
</script>

<template>
  <div class="footer-top pt-15 pt-sm-2">
    <VContainer>
      <VRow>
        <!-- 👉 Footer  -->
        <VCol
          cols="12"
          md="6"
        >
          <div
            class="mb-4"
            :class="$vuetify.display.smAndDown ? 'w-100' : 'w-75'"
          >
            <div class="d-flex align-center gap-x-3 mb-4">
              <Logo
                fill-color="#FFF"
                style="width:150px;"
              />
              <h3 class="text-h3 text-white text-capitalize">
                {{ themeConfig.app.appName }}
              </h3>
            </div>
            <div
              class="mb-8"
              :class="$vuetify.theme.current.dark ? 'text-body-1' : 'text-white-variant'"
            >
              {{ $t('Slogan') }}
            </div>
          </div>
        </VCol>

        <!-- 👉 Pages  -->
        <VCol
          cols="12"
          md="6"
          sm="6"
        >
          <div class="font-weight-medium mb-6">
            {{ $t('LinkBarLegal') }}
          </div>
          <ul style="list-style: none;">
            <li
              v-for="(item, index) in pagesList"
              :key="index"
              class="mb-4"
            >
              <NuxtLink
                :class="$vuetify.theme.current.dark ? 'text-body-1' : 'text-white-variant'"
                class="me-2"
                :to="item.to"
              >
                {{ $t(item.name) }}
              </NuxtLink>
            </li>
          </ul>
        </VCol>
      </VRow>
    </VContainer>
  </div>

  <!-- 👉 Footer Line -->  
  <div class="text-white-variant footer-line">
    <VContainer>
      <div class="d-flex justify-space-between flex-wrap gap-y-4 align-center">
        <span class="text-wrap me-4 me-sm-0 ma-sm-auto">
          &copy;

          {{ $dayjs().year() }}
          <NuxtLink
            to="/"
            class="font-weight-bold ms-1 text-white"
          >
            {{ themeConfig.app.title }}
          </NuxtLink>
        </span>

        <div class="d-flex gap-x-6 ma-sm-auto">
          <AuthProvider full-dark />
        </div>
      </div>
    </VContainer>
  </div>
</template>

<style lang="scss" scoped>
.footer-top {
  border-radius: 60px 60px 0 0;
  background-size: cover;
  color: #fff;
  background-color: #022c46;
  width: calc(100%) !important; // + 8rem
  margin: 0; //-4rem
}

.footer-line {
  background: #171925;
  margin: 0; //-4rem
  width: calc(100%) !important; // + 8 rem
}

@media (max-width: 600px) {
  .footer-top {
    border-radius: 0;
    width: calc(100%) !important;// + 48px
    margin: 0;// - 24px
  }
  .footer-line {
    width: calc(100% ) !important; // + 48px
    margin: 0;// - 24px
  }
}
</style>


<style lang="scss">
.footer {
  //border-radius: 50%;
  background: blue;

  @media (min-width: 600px) and (max-width: 960px) {
    .v-container {
      padding-inline: 2rem !important;
    }
  }
}
</style>
